/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Renewdate1Inputs */

const zh_subscription_renewdate1 = /** @type {(inputs: Subscription_Renewdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`续费日期:`)
};

const en_subscription_renewdate1 = /** @type {(inputs: Subscription_Renewdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renews on:`)
};

const es_subscription_renewdate1 = /** @type {(inputs: Subscription_Renewdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de renovación:`)
};

/**
* | output |
* | --- |
* | "Renews on:" |
*
* @param {Subscription_Renewdate1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_renewdate1 = /** @type {((inputs?: Subscription_Renewdate1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Renewdate1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_renewdate1(inputs)
	if (locale === "en") return en_subscription_renewdate1(inputs)
	return es_subscription_renewdate1(inputs)
});
export { subscription_renewdate1 as "subscription_renewDate" }